import React from 'react';
import cx from 'classnames';
import { Button } from '@mc/wink';
import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';
import ClusterLayout from '../ClusterLayout';
import usePopover from './usePopover';
import stylesheet from './Popover.css';

type CancelButtonProps = {
  hideCancelButton?: boolean;
  cancelButtonText?: string;
  handleCancelClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

export type PopoverFooterProps = {
  /** The footer content inside the Popover.  */
  children?: React.ReactNode;
  /** Change the content justification for the footer. To ensure design consistency, Only a subset (flex-end and `space-between`)
   * of normal justification choices are available.
   */
  justifyContent?: 'flex-end' | 'space-between';
  /** Additional class names to apply to the footer. */
  className?: string;
} & CancelButtonProps;

const PopoverFooter = ({
  children,
  className,
  justifyContent = 'flex-end',
  hideCancelButton,
  cancelButtonText,
  handleCancelClick,
  ...rest
}: PopoverFooterProps) => {
  const popover = usePopover();

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    (popover as $TSFixMe).close();
    if (handleCancelClick) {
      handleCancelClick(e);
    }
  };

  // Translation for default icon button label text
  const defaultCancelButtonText = useDsTranslateMessage({
    id: 'mcds.popover_cancel_button.button_text',
    defaultMessage: 'Cancel',
  });

  return (
    <div className={cx(stylesheet.footer, className)} {...rest}>
      <ClusterLayout
        justifyContent={justifyContent}
        className={stylesheet.footerContent}
      >
        {!hideCancelButton && (
          <Button type="quaternary" size="small" onClick={handleClick}>
            {cancelButtonText || defaultCancelButtonText}
          </Button>
        )}
        {children}
      </ClusterLayout>
    </div>
  );
};

export default PopoverFooter;
